import { LengthType } from "./LengthType";
import LengthValue from "./LengthValue";
import { LengthValueMillimeter } from "./LengthValueMillimeter";


export abstract class Length {
    abstract get lengthType(): LengthType;

    abstract get value(): number 

    //abstract lengthValue?: LengthValue;

    get isRange(): boolean {
        return this.lengthType === LengthType.Range;
    }

    get isStar(): boolean {
        return this.lengthType === LengthType.Star;
    }

    get isAuto(): boolean {
        return this.lengthType === LengthType.Auto;
    }

    equals(other: Length): boolean {
        return this.lengthType === other.lengthType && this.toString() === other.toString();
    }

    static equals(gl1: Length, gl2: Length): boolean {
        return gl1.equals(gl2);
    }

    static notEquals(gl1: Length, gl2: Length): boolean {
        return !gl1.equals(gl2);
    }

}
